// Link to full site
export const FULL_TEST_SITE_LINK = "https://test.psybooks.com";
export const FULL_PROD_SITE_LINK = "https://secure.psybooks.com";

// Global messages to be shown
export const ERROR_MESSSAGE = {
  date: "incorrect date",
  time: "incorrect time",
  appointmentType: "incorrect appointment type selected",
  repeatDate: "incorrect start repeat or end repeat dates",
  officeLocation: "incorrect office location selected",
  name: "incorrect name",
  firstName: "First name is required",
  lastName: "Last name is required",
  email: "incorrect email",
  emailExist: "Email already exist",
  dob: "incorrect date of birth",
  futureDob: "date of birth cannot be in the future",
  phone: "incorrect phone",
  groupList: "No group member added",
  stateCode: "incorrect state code",
  postalCode: "incorrect zip code",
  clientAdded:
    "Client added successfully, but you don't have enough permission to view or add an appointment",
  videoAppointment:
    "video appointment cannot be made in a previous date and time",
  insuranceCompany: "invalid insurance company selected",
  insuranceId: "incorrect insurance id",
  500: "something went wrong, please try again later",
  videoAppointmentResponse: "user doesn't have phone number or email",
  401: "session is invalid or session has expired",
  newMessage: "You have a received a new message",
  newMail: "You have a received a new mail",
  forgotPasswordInvalid: "The token sent is invalid",
  forgotPasswordSuccess: "Please check your email for additional information.",
  forgotPasswordUnSuccess:
    "Ooops! You did not answer enough questions successfully. Please try again",
  passwordResetSuccessful: "Password updated successfully",
  videoSessionLogin: "Not able to login. Please try again later",
  addAppointmentNoEmail:
    "One or more contact doesn’t have an email address so you can not send email reminders",
  addAppointmentNoPhone:
    "One or more contact doesn’t have a phone number so you can not send SMS reminders",
  search: "Please enter a search term",
  searchFilter: "Please select a filter",
  popUpBlocker:
    "A popup blocker is preventing your session from opening. Please check the browser’s settings on your phone to disable the popup blocker."
};
